import { ImageRun, Table, TableRow, TableCell, WidthType, BorderStyle, VerticalAlign, AlignmentType, HeightRule, TextRun, ShadingType, Paragraph, TableLayoutType, HorizontalPositionRelativeFrom, VerticalPositionRelativeFrom, HorizontalPositionAlign, VerticalPositionAlign, TextWrappingType } from "docx";

export const SCALE = 1.6;
export const FULL_WIDTH = 11906;

export const COMMON_HEADER_HEIGHT = 800;
export const COMMON_FOOTER_HEIGHT = 800;

// Reusable Standard Header with Page Heading
export const createCommonHeader = (title, bgColor = "#545454") => {
    return new Table({
        width: { size: FULL_WIDTH, type: WidthType.DXA },
        borders: {
            top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE },
            left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE },
            insideHorizontal: { style: BorderStyle.NONE }, insideVertical: { style: BorderStyle.NONE }
        },
        rows: [new TableRow({
            height: { value: COMMON_HEADER_HEIGHT, rule: HeightRule.EXACT },
            children: [new TableCell({
                shading: { fill: fixColor(bgColor), type: ShadingType.CLEAR },
                verticalAlign: VerticalAlign.CENTER,
                children: [new Paragraph({
                    alignment: AlignmentType.CENTER,
                    children: [new TextRun({
                        text: title || "",
                        color: "FFFFFF",
                        bold: true,
                        size: 18 * SCALE,
                        font: "sans-serif"
                    })]
                })]
            })]
        })]
    });
};

// Reusable Standard Footer with Page Numbering
export const createCommonFooter = (pageNum, bgColor = "#545454") => {
    return new Table({
        width: { size: FULL_WIDTH, type: WidthType.DXA },
        borders: {
            top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE },
            left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE },
            insideHorizontal: { style: BorderStyle.NONE }, insideVertical: { style: BorderStyle.NONE }
        },
        rows: [new TableRow({
            height: { value: COMMON_FOOTER_HEIGHT, rule: HeightRule.EXACT },
            children: [new TableCell({
                shading: { fill: fixColor(bgColor), type: ShadingType.CLEAR },
                verticalAlign: VerticalAlign.BOTTOM,
                children: [new Paragraph({
                    alignment: AlignmentType.RIGHT,
                    indent: { right: 200 },
                    spacing: { after: 200 },
                    children: [createPageNumberRun(pageNum)]
                })]
            })]
        })]
    });
};

// Reusable Stripe Header with Page Heading
export const createStripeHeader = (title, bannerColor = "4a4a4a", stripeColor = "#bec6d4") => {
    const leftStripeRun = getStripeRun("left", stripeColor);
    return new Table({
        width: { size: FULL_WIDTH, type: WidthType.DXA },
        layout: TableLayoutType.FIXED,
        borders: {
            top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE },
            left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE },
            insideHorizontal: { style: BorderStyle.NONE }, insideVertical: { style: BorderStyle.NONE }
        },
        rows: [
            new TableRow({
                height: { value: 800, rule: HeightRule.EXACT },
                children: [
                    new TableCell({
                        shading: { fill: fixColor(bannerColor) },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                layout: TableLayoutType.FIXED,
                                borders: {
                                    top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE },
                                    left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE },
                                    insideHorizontal: { style: BorderStyle.NONE }, insideVertical: { style: BorderStyle.NONE }
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 25, type: WidthType.PERCENTAGE }, children: [new Paragraph({ indent: { left: 200 }, children: [leftStripeRun] })]
                                            }),
                                            new TableCell({
                                                width: { size: 50, type: WidthType.PERCENTAGE },
                                                verticalAlign: VerticalAlign.CENTER,
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.CENTER,
                                                        children: [
                                                            new TextRun({
                                                                text: title || "",
                                                                color: "FFFFFF",
                                                                bold: true,
                                                                size: 18 * SCALE,
                                                                font: "sans-serif"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [new Paragraph({ children: [] })] })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// Reusable Stripe Footer with Page Numbering
export const createStripeFooter = (pageNum, bannerColor = "4a4a4a", stripeColor = "#bec6d4") => {
    const rightStripeRun = getStripeRun("right", stripeColor);
    return new Table({
        width: { size: FULL_WIDTH, type: WidthType.DXA },
        layout: TableLayoutType.FIXED,
        borders: {
            top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE },
            left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE },
            insideHorizontal: { style: BorderStyle.NONE }, insideVertical: { style: BorderStyle.NONE }
        },
        rows: [
            new TableRow({
                height: { value: 800, rule: HeightRule.EXACT },
                children: [
                    new TableCell({
                        shading: { fill: fixColor(bannerColor) },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                layout: TableLayoutType.FIXED,
                                borders: {
                                    top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE },
                                    left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE },
                                    insideHorizontal: { style: BorderStyle.NONE }, insideVertical: { style: BorderStyle.NONE }
                                },
                                rows: [
                                    new TableRow({
                                        height: { value: 800, rule: HeightRule.EXACT },
                                        children: [
                                            new TableCell({
                                                width: { size: 95, type: WidthType.PERCENTAGE },
                                                verticalAlign: VerticalAlign.CENTER,
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.RIGHT,
                                                        indent: { right: 200 },
                                                        children: [
                                                            rightStripeRun
                                                        ]
                                                    })
                                                ]
                                            }),
                                            new TableCell({
                                                width: { size: 5, type: WidthType.PERCENTAGE },
                                                verticalAlign: VerticalAlign.BOTTOM,
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.RIGHT,
                                                        indent: { right: 200 },
                                                        spacing: { after: 200 },
                                                        children: [
                                                            createPageNumberRun(pageNum)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// Helper to get a Stripe ImageRun
export const getStripeRun = (side, color = "#bec6d4", widthDXA = 3000, heightDXA = 800) => {
    const data = generateStripeImage(side, color);
    return fitImage(data, widthDXA, heightDXA, "contain");
};

// Standard Page Number TextRun
export const createPageNumberRun = (pageNum, color = "FFFFFF", size = 22) => {
    return new TextRun({
        text: pageNum ? String(pageNum).padStart(2, '0') : "",
        color: fixColor(color),
        bold: true,
        size: size,
        font: "Helvetica"
    });
};

// Fix and return hex color string, with optional fallback for visibility
export const fixColor = (color, fallback = "000000") => {
    if (!color) return fallback.replace('#', '');
    let clean = color.toString().replace('#', '');
    if (clean.length === 3) clean = clean.split('').map(c => c + c).join('');
    if (clean.length !== 6) return fallback.replace('#', '');
    return clean;
};

// Shared Org Chart Text Drawing (Prevents overlap)
export const drawOrgText = (ctx, { name, role, nameStyle, roleStyle, x, y, width, contrastColor }) => {
    // 1. Font Setup - Force Number to avoid string concatenation bugs
    const nameSize = Number(nameStyle.size) || 12;
    const nameWeight = nameStyle.bold === false ? 'normal' : 'bold'; // default bold for names
    const nameFont = nameStyle.font || 'sans-serif';
    const nameFullFont = `${nameStyle.italic ? 'italic' : ''} ${nameWeight} ${nameSize}px ${nameFont}`;

    const roleSize = Number(roleStyle.size) || 10;
    const roleWeight = roleStyle.bold ? 'bold' : 'normal';
    const roleFont = roleStyle.font || 'sans-serif';
    const roleFullFont = `${roleStyle.italic ? 'italic' : ''} ${roleWeight} ${roleSize}px ${roleFont}`;

    ctx.textAlign = "center";
    ctx.textBaseline = "top";

    // 2. Name Rendering
    ctx.font = nameFullFont;
    let rawNColor = nameStyle.color;
    // Special: If color is explicitly white or missing, use contrastColor or orange
    if (!rawNColor || rawNColor.replace('#', '') === "FFFFFF") {
        ctx.fillStyle = contrastColor || "#ff6600";
    } else {
        ctx.fillStyle = "#" + fixColor(rawNColor);
    }

    const nameLines = getWrappedLines(ctx, name, width - 10);
    const nameLH = nameSize + 2;
    let currentY = Number(y);

    nameLines.forEach(line => {
        ctx.fillText(line, x, currentY);
        if (nameStyle.underline) {
            const metrics = ctx.measureText(line);
            ctx.beginPath();
            ctx.strokeStyle = ctx.fillStyle;
            ctx.lineWidth = 1;
            ctx.moveTo(x - metrics.width / 2, currentY + nameSize);
            ctx.lineTo(x + metrics.width / 2, currentY + nameSize);
            ctx.stroke();
        }
        currentY += nameLH;
    });

    currentY += 4; // Margin between name and role

    // 3. Role Rendering
    ctx.font = roleFullFont;
    let rawRColor = roleStyle.color;
    // Same logic for role
    if (!rawRColor || rawRColor.replace('#', '') === "FFFFFF") {
        ctx.fillStyle = contrastColor || "#0033cc";
    } else {
        ctx.fillStyle = "#" + fixColor(rawRColor);
    }

    const roleLines = getWrappedLines(ctx, role, width - 10);
    const roleLH = roleSize * 1.2;

    roleLines.forEach(line => {
        ctx.fillText(line, x, currentY);
        if (roleStyle.underline) {
            const metrics = ctx.measureText(line);
            ctx.beginPath();
            ctx.strokeStyle = ctx.fillStyle;
            ctx.lineWidth = 1;
            ctx.moveTo(x - metrics.width / 2, currentY + roleSize);
            ctx.lineTo(x + metrics.width / 2, currentY + roleSize);
            ctx.stroke();
        }
        currentY += roleLH;
    });

    return currentY; // Return bottom for connector calc
};

export const hexToRGBA = (hex, opacity) => {
    if (!hex) return `rgba(0,0,0,${opacity})`;
    let r = 0, g = 0, b = 0;
    // Normalize hex
    const cleanHex = hex.replace('#', '');
    if (cleanHex.length === 3) {
        r = parseInt(cleanHex[0] + cleanHex[0], 16);
        g = parseInt(cleanHex[1] + cleanHex[1], 16);
        b = parseInt(cleanHex[2] + cleanHex[2], 16);
    } else if (cleanHex.length === 6) {
        r = parseInt(cleanHex.substring(0, 2), 16);
        g = parseInt(cleanHex.substring(2, 4), 16);
        b = parseInt(cleanHex.substring(4, 6), 16);
    }
    return `rgba(${r},${g},${b},${opacity})`;
};

// Fit Image
export const fitImage = (imgData, targetWidthDXA, targetHeightDXA, mode = "cover") => {
    if (!imgData || !imgData.data || imgData.width === 0 || imgData.height === 0) return null;

    const targetWidthPx = targetWidthDXA / 15;
    const targetHeightPx = targetHeightDXA / 15;

    const imgW = imgData.width;
    const imgH = imgData.height;

    let finalW, finalH;
    let cropping = null;

    if (mode === "cover") {
        const scale = Math.max(targetWidthPx / imgW, targetHeightPx / imgH);
        const scaledW = imgW * scale;
        const scaledH = imgH * scale;

        // Use target dimensions for transformation
        finalW = targetWidthPx;
        finalH = targetHeightPx;

        // Calculate cropping (percentages in 1/100,000 units)
        const totalCropW = scaledW - targetWidthPx;
        const totalCropH = scaledH - targetHeightPx;

        cropping = {
            left: Math.max(0, Math.floor((totalCropW / scaledW / 2) * 100000)),
            right: Math.max(0, Math.floor((totalCropW / scaledW / 2) * 100000)),
            top: Math.max(0, Math.floor((totalCropH / scaledH / 2) * 100000)),
            bottom: Math.max(0, Math.floor((totalCropH / scaledH / 2) * 100000)),
        };
    } else if (mode === "fill") {
        finalW = targetWidthPx;
        finalH = targetHeightPx;
    } else {
        const scale = Math.min(targetWidthPx / imgW, targetHeightPx / imgH);
        finalW = imgW * scale;
        finalH = imgH * scale;
    }

    return new ImageRun({
        data: imgData.data,
        transformation: {
            width: finalW,
            height: finalH,
            cropping: cropping,
        },
    });
};

export const fitFloatingImage = (imgData, targetWidthDXA, targetHeightDXA, floatingOptions = {}) => {
    if (!imgData || !imgData.data || imgData.width === 0 || imgData.height === 0) return null;

    const targetWidthPx = targetWidthDXA / 15;
    const targetHeightPx = targetHeightDXA / 15;
    const imgW = imgData.width;
    const imgH = imgData.height;

    // "Cover" logic
    const scale = Math.max(targetWidthPx / imgW, targetHeightPx / imgH);
    const scaledW = imgW * scale;
    const scaledH = imgH * scale;

    const totalCropW = scaledW - targetWidthPx;
    const totalCropH = scaledH - targetHeightPx;

    const cropping = {
        left: Math.max(0, Math.floor((totalCropW / scaledW / 2) * 100000)),
        right: Math.max(0, Math.floor((totalCropW / scaledW / 2) * 100000)),
        top: Math.max(0, Math.floor((totalCropH / scaledH / 2) * 100000)),
        bottom: Math.max(0, Math.floor((totalCropH / scaledH / 2) * 100000)),
    };

    return new ImageRun({
        data: imgData.data,
        transformation: {
            width: targetWidthPx,
            height: targetHeightPx,
            cropping: cropping,
        },
        floating: {
            horizontalPosition: {
                relative: HorizontalPositionRelativeFrom.COLUMN,
                offset: 0,
            },
            verticalPosition: {
                relative: VerticalPositionRelativeFrom.PARAGRAPH,
                offset: 0,
            },
            zIndex: 0,
            behindDocument: true,
            wrap: { type: TextWrappingType.BEHIND },
            ...floatingOptions
        }
    });
};

// Fetch Image With Dimensions
export const fetchImageWithDimensions = async (url) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const arrayBuffer = await blob.arrayBuffer();

        // Use a temporary image to get dimensions in browser context
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                resolve({
                    data: new Uint8Array(arrayBuffer),
                    width: img.width,
                    height: img.height
                });
            };
            img.onerror = () => {
                resolve(null);
            };
            img.src = URL.createObjectURL(blob);
        });
    } catch (e) {
        console.warn("Failed to fetch image dimensions", url, e);
        return null; // Return null to indicate failure
    }
};

// Generate Stripe Pattern Image (Canvas)
export const generateStripeImage = (side, color = "#bec6d4") => {
    const canvas = document.createElement('canvas');
    canvas.width = 250;
    canvas.height = 60;
    const ctx = canvas.getContext('2d');

    ctx.fillStyle = color;
    const stripeWidth = 5;
    const stripeHeight = 40;
    const gap = 20;
    const angle = (side === "left" ? -45 : 45) * (Math.PI / 180);

    const totalW = (8 * stripeWidth) + (7 * gap);
    const startX = (canvas.width - totalW) / 2;

    for (let i = 0; i < 8; i++) {
        ctx.save();
        ctx.translate(startX + i * (stripeWidth + gap) + stripeWidth / 2, canvas.height / 2);
        ctx.rotate(angle);
        ctx.fillRect(-stripeWidth / 2, -stripeHeight / 2, stripeWidth, stripeHeight);
        ctx.restore();
    }

    return {
        data: Uint8Array.from(atob(canvas.toDataURL("image/png").split(',')[1]), c => c.charCodeAt(0)),
        width: 250,
        height: 60
    };
};

// Draw Placeholder User Icon
export const drawPlaceholderIcon = (ctx, x, y, size) => {
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(x, y, size, size);

    ctx.fillStyle = "#FFFFFF";
    // Head
    ctx.beginPath();
    ctx.arc(x + size / 2, y + size * 0.4, size * 0.15, 0, Math.PI * 2);
    ctx.fill();
    // Body
    ctx.beginPath();
    ctx.arc(x + size / 2, y + size * 1.0, size * 0.3, Math.PI, 0);
    ctx.fill();
};

// Draw Resume Placeholder Person Avatar
export const drawResumePlaceholderIcon = (ctx, x, y, width, height, bgColor) => {
    ctx.fillStyle = bgColor ? (bgColor.startsWith('#') ? bgColor : "#" + bgColor) : "#f0f0f0";
    ctx.fillRect(x, y, width, height);

    ctx.fillStyle = "#FFFFFF";
    const size = Math.min(width, height);
    const centerX = x + width / 2;
    const centerY = y + height / 2;

    // Head
    ctx.beginPath();
    ctx.arc(centerX, centerY - size * 0.1, size * 0.15, 0, Math.PI * 2);
    ctx.fill();
    // Body
    ctx.beginPath();
    ctx.arc(centerX, centerY + size * 0.5, size * 0.3, Math.PI, 0);
    ctx.fill();
};

// Draw Org Chart Placeholder Person Avatar
export const generatePlaceholderImage = (size = 300) => {
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');

    drawPlaceholderIcon(ctx, 0, 0, size);

    const dataUrl = canvas.toDataURL("image/png");
    const base64 = dataUrl.split(',')[1];
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }

    return {
        data: bytes,
        width: size,
        height: size
    };
};

// Generate Resume Placeholder Image
export const generateResumePlaceholderImage = (width = 300, height = 300, bgColor) => {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');

    drawResumePlaceholderIcon(ctx, 0, 0, width, height, bgColor);

    const dataUrl = canvas.toDataURL("image/png");
    const base64 = dataUrl.split(',')[1];
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }

    return {
        data: bytes,
        width: width,
        height: height
    };
};

// Check Contrast (Direct Hex Input)
export const getContrastColor = (hex) => {
    const cleanHex = hex.replace('#', '');
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? "#000000" : "#FFFFFF";
};

// Canvas Text Wrapping Utility
export const getWrappedLines = (ctx, text, maxWidth) => {
    if (!text) return [];
    const words = text.split(/\s+/);
    let line = '';
    const lines = [];

    for (let n = 0; n < words.length; n++) {
        const testLine = line + (line ? ' ' : '') + words[n];
        const metrics = ctx.measureText(testLine);
        if (metrics.width > maxWidth && n > 0) {
            lines.push(line);
            line = words[n];
        } else {
            line = testLine;
        }
    }
    if (line) lines.push(line);
    return lines;
};

// Build recursive tree from flat array
export const buildOrgTree = (members) => {
    const map = {};
    const roots = [];
    if (!members || members.length === 0) return [];
    const membersCopy = members.map(m => ({ ...m, children: [] }));
    membersCopy.forEach(m => map[m.teamMemberId] = m);
    membersCopy.forEach(m => {
        if (m.reportsToId && map[m.reportsToId]) {
            map[m.reportsToId].children.push(m);
        } else {
            roots.push(m);
        }
    });
    return roots;
};

// Get Max Depth of Tree
export const getMaxOrgDepth = (nodes) => {
    if (!nodes || nodes.length === 0) return 0;
    let d = 1;
    nodes.forEach(n => {
        if (n.children && n.children.length > 0) d = Math.max(d, 1 + getMaxOrgDepth(n.children));
    });
    return d;
};
